import React, { useState, useEffect } from 'react';
import PropTypes, { any } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreator from "../../../store/actions/index";
import { Button, useTheme, makeStyles, Badge } from "@material-ui/core";
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import ErrorIcon from '@material-ui/icons/Error';
import RouteIcon from '@material-ui/icons/Timeline';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import MenuIcon from '@material-ui/icons/Menu';
import RouteSummaryDialog from "./RouteSummaryDialog/RouteSummaryDialog";
import { themeTypeToBool, notArrayOrEmpty } from '../../../utils/helpers';
import CustomCheckbox from "../../Common/CustomCheckbox";
import { TooltipTop as CustomTooltip } from "../../Common/CustomTooltips";
import t from "../../../languages/pl";
import { typeRoute, typeRefuel, typeZone, typeWarning } from './../../../utils/staticData';
import { array } from 'prop-types';

const useStyles = makeStyles(theme => ({
    buttons: {
        position: "relative",
        display: "flex",
        borderTop: "2px solid",
        borderColor: "#A5A4BF",
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        background: themeTypeToBool(theme.palette.type) ? "#C6C6E8" : "#8180cc",
    },
    button: {
        margin: theme.spacing(1),
        minWidth: 30,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    checkbox: {
        position: "absolute",
        right: theme.spacing(1),
        top: 5
    },
    checkboxStyle: {
        color: "#A5A4BF"
    },
    badgeLocation: {
        top: "25%",
        right: "25%"
    }
}));

const countRouteOfType = (routes, type) => {
    if(notArrayOrEmpty(routes))
        return 0;
    return routes.filter(route => route.type === type).length;
};

const SingleCarButtons = props => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const { registrationNo, driveFilter, refuelFilter, regionFilter, warningsFilter, startDate, endDate, selectedRoutes, routes, currentRoute, showCurrentRoute } = props;
    const buttonActiveColor = "#43425D";
    const buttonNotActiveColor = "#A5A4BF";

    const [openDialog, setDialogOpen] = useState(false);
    const [anyRouteSelected, setAnyRouteSelected] = useState(false);
    const [allRouteSelected, setAllRouteSelected] = useState(false);
    const [currentRouteData, setCurrentRouteData] = useState([]);

    useEffect(() => {
        if(currentRoute){
            setCurrentRouteData(currentRoute.data)
        }
    }, [currentRoute])

    useEffect(() => {
        if ((!routes || routes.length === 0) && showCurrentRoute) {
            setAllRouteSelected(true);
            setAnyRouteSelected(true);
        }
        else if ((!routes || routes.length === 0) && !showCurrentRoute) {
            setAllRouteSelected(false);
            setAnyRouteSelected(false);
        }
        else if (!selectedRoutes || selectedRoutes.filter(route => route.type !== "postoje").length === 0) {
            if (currentRouteData && showCurrentRoute) {
                setAllRouteSelected(false);
                setAnyRouteSelected(true);
            }
            else if (currentRouteData && !showCurrentRoute) {
                setAllRouteSelected(false);
                setAnyRouteSelected(false);
            }
            else {
                setAllRouteSelected(false);
                setAnyRouteSelected(false);
            }
        }
        else if (Array.isArray(routes) && selectedRoutes.length === routes.length) {
            if (currentRouteData && showCurrentRoute) {
                setAllRouteSelected(true);
                setAnyRouteSelected(true);
            }
            else if (currentRouteData && (!showCurrentRoute && currentRouteData.length > 0)) {
                setAllRouteSelected(false);
                setAnyRouteSelected(true);
            }
            else {
                setAllRouteSelected(true);
                setAnyRouteSelected(true);
            }
        }
        else if (selectedRoutes !== routes) {
            setAllRouteSelected(false);
            setAnyRouteSelected(true);
        }
    }, [selectedRoutes, routes, showCurrentRoute]);

    useEffect(() => {
        if (currentRouteData && showCurrentRoute) {
            setAnyRouteSelected(true);
        }
        else {
            if (selectedRoutes && selectedRoutes.length > 0)
                setAnyRouteSelected(true);
            else
                setAnyRouteSelected(false);
        }
    }, [showCurrentRoute]);

    const closeDialog = () => {
        setDialogOpen(false);
    };

    const handleCheckboxClick = () => {
        if ((routes && routes.length > 0) || (currentRouteData && currentRouteData.length > 0)) {
            if ((!routes || routes.length === 0)) {
                if (currentRouteData && showCurrentRoute) {
                    setAllRouteSelected(false);
                    setAnyRouteSelected(false);
                    props.changeShowingCurrentRoute(false);
                }
                else if (currentRouteData && !showCurrentRoute) {
                    setAllRouteSelected(true);
                    setAnyRouteSelected(true);
                    props.changeShowingCurrentRoute(true);
                }
            }
            else if (!allRouteSelected && !anyRouteSelected) {
                props.selectAllRoutes();
                if (currentRouteData && currentRouteData.length > 0)
                    props.changeShowingCurrentRoute(true);
            }
            else {
                props.deselectAllRoutes();
                if (currentRouteData && currentRouteData.length > 0)
                    props.changeShowingCurrentRoute(false);
            }
        }
    };

    useEffect(() => {
        if (selectedRoutes) {
            if(allRouteSelected && driveFilter ){
                props.changeRoutesMarksVisibility(true, typeRoute);
            } else{
                props.changeRoutesMarksVisibility(false, typeRoute);
            }
        }
    }, [driveFilter]);

    useEffect(() => {
        if (selectedRoutes) {
            if(allRouteSelected && refuelFilter ){
                props.changeRoutesMarksVisibility(true, typeRefuel);
            } else{
                props.changeRoutesMarksVisibility(false, typeRefuel);
            }
        }
    }, [refuelFilter]);

    useEffect(() => {
        if (selectedRoutes) {
            if(allRouteSelected && regionFilter ){
                props.changeRoutesMarksVisibility(true, typeZone);
            } else{
                props.changeRoutesMarksVisibility(false, typeZone);
            }
        }
    }, [regionFilter]);

    useEffect(() => {
        if (selectedRoutes) {
            if(allRouteSelected && warningsFilter ){
                props.changeRoutesMarksVisibility(true, typeWarning);
            } else{
                props.changeRoutesMarksVisibility(false, typeWarning);
            }
        }
    }, [warningsFilter]);

    return (
        <React.Fragment>
            <div className={classes.buttons}>
                <CustomTooltip title={t.routes}>
                    <Badge
                        badgeContent={countRouteOfType(routes, typeRoute)}
                        overlap='circle'
                        color='secondary'
                        classes={{anchorOriginTopRightCircle: classes.badgeLocation}}
                    >
                        <Button
                            className={classes.button}
                            onClick={props.changeShowDriveFilter}
                        >
                            <RouteIcon style={{ color: driveFilter ? buttonActiveColor : buttonNotActiveColor }} />
                        </Button>
                    </Badge>
                </CustomTooltip>
                <CustomTooltip title={t.refuel}>
                    <Badge
                        badgeContent={countRouteOfType(routes, typeRefuel)}
                        overlap='circle'
                        color='secondary'
                        classes={{anchorOriginTopRightCircle: classes.badgeLocation}}
                    >
                        <Button
                            className={classes.button}
                            onClick={props.changeShowRefuelFilter}
                        >
                            <LocalGasStationIcon style={{ color: refuelFilter ? buttonActiveColor : buttonNotActiveColor }} />
                        </Button>
                    </Badge>
                </CustomTooltip>
                <CustomTooltip title={t.zoning}>
                    <Badge
                        badgeContent={countRouteOfType(routes, typeZone)}
                        overlap='circle'
                        color='secondary'
                        classes={{anchorOriginTopRightCircle: classes.badgeLocation}}
                    >
                        <Button
                            className={classes.button}
                            onClick={props.changeShowOutOfRegionFilter}
                        >
                            <GpsFixedIcon style={{ color: regionFilter ? buttonActiveColor : buttonNotActiveColor }} />
                        </Button>
                    </Badge>
                </CustomTooltip>
                <CustomTooltip title={t.incidents}>
                    <Badge
                        badgeContent={countRouteOfType(routes, typeWarning)}
                        overlap='circle'
                        color='secondary'
                        classes={{anchorOriginTopRightCircle: classes.badgeLocation}}
                    >
                        <Button
                            className={classes.button}
                            onClick={props.changeShowWarningsFilter}
                        >
                            <ErrorIcon style={{ color: warningsFilter ? buttonActiveColor : buttonNotActiveColor }} />
                        </Button>
                    </Badge>
                </CustomTooltip>
                <CustomTooltip title={t.routesDetails}>
                    <Button
                        className={classes.button}
                        onClick={() => setDialogOpen(true)}
                    >
                        <MenuIcon style={{ color: buttonNotActiveColor }} />
                    </Button>
                </CustomTooltip>
                <CustomTooltip title={anyRouteSelected ? t.deselectAllElements : t.selectAllElementes}>
                    <div className={classes.checkbox}>
                        <CustomCheckbox
                            classes={{ root: classes.checkboxStyle }}
                            indeterminate={anyRouteSelected && !allRouteSelected}
                            checked={anyRouteSelected}
                            onClick={handleCheckboxClick}
                        />
                    </div>
                </CustomTooltip>
            </div>
            {openDialog && <RouteSummaryDialog
                open={openDialog}
                onClose={closeDialog}
                name={registrationNo}
                startDate={startDate}
                endDate={endDate}
                routes={routes} />}
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        selectedRoutes: state.mapRoutesReducer.selectedRoutes,
        driveFilter: state.filterReducer.drive,
        refuelFilter: state.filterReducer.refuel,
        regionFilter: state.filterReducer.outOfZone,
        warningsFilter: state.filterReducer.warnings,
        startDate: state.filterReducer.startDate,
        endDate: state.filterReducer.endDate,
        routes: state.mapRoutesReducer.routes,
        currentRoute: state.mapRoutesReducer.currentRoute,
        showCurrentRoute: state.mapRoutesReducer.showCurrentRoute,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SingleCarButtons);

SingleCarButtons.propTypes = {
    registrationNo: PropTypes.string,
    carId: PropTypes.string,
    //redux
    selectedRoutes: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    routes: PropTypes.array,
    currentRoute: PropTypes.object,
    showCurrentRoute: PropTypes.bool,
    driveFilter: PropTypes.bool,
    refuelFilter: PropTypes.bool,
    regionFilter: PropTypes.bool,
    warningsFilter: PropTypes.bool,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    changeShowDriveFilter: PropTypes.func,
    changeShowRefuelFilter: PropTypes.func,
    changeShowOutOfRegionFilter: PropTypes.func,
    changeShowWarningsFilter: PropTypes.func,
    selectAllRoutes: PropTypes.func,
    deselectAllRoutes: PropTypes.func,
    changeRoutesVisibility: PropTypes.func,
    changeRefuelsVisibility: PropTypes.func,
    changeWarningsVisibility: PropTypes.func,
    changeZoneVisibility: PropTypes.func,
    changeRoutesMarksVisibility: PropTypes.func,
    changeShowingCurrentRoute: PropTypes.func,
};